import { z } from 'zod';

import { schemaErrorProcessingFailed, schemaErrorUnprocessable } from './Errors';
import { schemaEuropaceOffer } from '../Angebote';

export const schemaEuropaceOffersResponse = z.object({
    data: z.object({
        angebote: z.array(schemaEuropaceOffer),
    }),
    errors: z.array(z.union([schemaErrorUnprocessable, schemaErrorProcessingFailed])),
});

export type SchemaEuropaceOffersResponse = z.infer<typeof schemaEuropaceOffersResponse>;
